<template>
    <modal-live ref="modal">
        <div class="dialog">
            <h2 class="headline--welcome text-center">About</h2>
            <div class="modal-scrollable">
                <p>
                    This site uses cookies to provide you with a great user
                    experience.
                </p>
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Eius ut error neque quod voluptate hic iusto rem
                    exercitationem recusandae perferendis sequi possimus dicta
                    enim repellat veritatis fugiat deleniti ipsa minus vero, ad
                    pariatur distinctio corrupti amet aliquid! Obcaecati sequi
                    cumque mollitia! Ducimus nam nesciunt excepturi totam hic
                    blanditiis tenetur aperiam.
                </p>
            </div>
            <div class="text-center pt-3">
                <Button @click.native="dismiss()"> Button </Button>
            </div>
        </div>
    </modal-live>
</template>

<script>
export default {
    methods: {
        dismiss() {
            this.$refs.modal.dismiss();
        },
    },
};
</script>

<style lang="scss"></style>
